export const VERSION = '4.86.2'; // x-release-please-version
//# sourceMappingURL=version.mjs.map